import createLucideIcon from '../createLucideIcon';

const Clock12 = createLucideIcon('Clock12', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12', key: '1fub01' }],
]);

export default Clock12;
